// ReturnDialog.jsx – Stammbaum an den Kunden zurückgeben (Status „Erstellt“) mit Nachricht
import React, { useState } from 'react';

export function ReturnDialog({ tree, email, busy, onCancel, onConfirm }) {
  const [message, setMessage] = useState('');
  return (
    <div onClick={busy ? undefined : onCancel} style={{
      position: 'fixed', inset: 0, zIndex: 2000, background: 'rgba(0,0,0,0.35)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', borderRadius: 12, padding: '22px 22px 18px', width: 'min(540px, 100%)',
        maxHeight: '90vh', overflow: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <h3 style={{ margin: 0, fontSize: 18 }}>An den Kunden zurückgeben</h3>
          <button onClick={onCancel} disabled={busy} style={{ border: 'none', background: 'none', fontSize: 22, cursor: 'pointer', color: '#888' }}>×</button>
        </div>
        <p style={{ fontSize: 14, color: '#555', lineHeight: 1.5, margin: '0 0 12px' }}>
          „{tree.name || tree.code}“ wird wieder auf <strong>Erstellt</strong> gesetzt. Der Kunde kann ihn danach
          wieder bearbeiten und erneut bestellen. <strong>Du hast ab dann keinen Zugriff mehr</strong>, bis er neu bestellt wird.
        </p>
        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 6 }}>
          Nachricht an den Kunden – warum wird der Stammbaum zurückgegeben?
        </label>
        <textarea
          autoFocus
          rows={6}
          maxLength={3000}
          value={message}
          onChange={e => setMessage(e.target.value)}
          placeholder="z.B. Bei Anna Muster fehlt noch das Geburtsdatum, und das Foto von Peter ist leider zu unscharf für den Druck. Kannst du ein besseres hochladen?"
          style={{
            width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8,
            border: '1.5px solid #d0d5e0', fontSize: 14, fontFamily: 'inherit', lineHeight: 1.5, resize: 'vertical',
          }}
        />
        <p style={{ fontSize: 12, color: '#888', lineHeight: 1.5, margin: '6px 0 14px' }}>
          {email ? <>Die Nachricht geht per E-Mail an <strong>{email}</strong> und </> : <>Die Nachricht </>}
          erscheint ausserdem oben im Stammbaum-Editor des Kunden, bis er erneut bestellt.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="admin-btn admin-btn--ghost admin-btn--sm" onClick={onCancel} disabled={busy}>Abbrechen</button>
          <button
            className="admin-btn admin-btn--primary admin-btn--sm"
            disabled={busy}
            onClick={() => {
              if (!message.trim() && !window.confirm('Ohne Nachricht zurückgeben? Der Kunde weiss dann nicht, was er ändern soll.')) return;
              onConfirm(message.trim());
            }}
          >
            {busy ? 'Wird zurückgegeben…' : 'Zurückgeben'}
          </button>
        </div>
      </div>
    </div>
  );
}
